/**
 * Timestamp utilities for consistent ISO 8601 timestamp generation
 * Used throughout the app to match API format
 */

/**
 * Get current timestamp in ISO 8601 format
 * Matches the API's DateTime serialization format
 */
export function getCurrentISOTimestamp(): string {
  return new Date().toISOString()
}
